module.exports = __webpack_public_path__ + "static/media/Flamenco Dancer.6da5c8f5.jpg";